import { VerificationChannel } from 'models/mobileVerification';
import client from '../utils/fetch-client';

const path = '/user';

export default {
	updateEmail(email = '') {
		return client.post(`${path}/email`, {
			body: {
				email,
			},
		});
	},

	sendEmailConfirmation() {
		return client.post(`${path}/email/resend-verification`);
	},

	verifyNumber(code: string) {
		return client.post(`${path}/cellphone/verify`, {
			body: {
				code,
			},
		});
	},

	resendVerificationCode(channel?: VerificationChannel) {
		return client.post(`${path}/cellphone/verify/resend${channel ? `?channel=${channel}` : ''}`);
	},
};
